import {
  PillarMetricSubtitleRow,
  PillarMetricWithInfo,
} from '@/components/ui/pillar-metric-with-info';
import { useBankingHeroMetrics } from '@/features/accounts/useBankingHeroMetrics';
import { useLanguage } from '@/i18n/language-hooks';
import { formatCurrency, useDefaultCurrency } from '@/lib/utils';
import { useMemo } from 'react';

export function useBankingPillarHero() {
  const { t } = useLanguage();
  const currency = useDefaultCurrency();
  const { checkingBalance, monthlySalary, isLoading } = useBankingHeroMetrics();

  return useMemo(
    () => ({
      title: (
        <PillarMetricWithInfo
          value={formatCurrency(checkingBalance, currency)}
          numericValue={checkingBalance}
          formatValue={(n) => formatCurrency(n, currency)}
          info={t('banking.hero.checkingBalanceInfo')}
          infoAriaLabel={t('banking.hero.checkingBalanceInfoAria')}
          isLoading={isLoading}
        />
      ),
      subtitle: (
        <PillarMetricSubtitleRow
          label={t('banking.hero.monthlySalary')}
          value={formatCurrency(monthlySalary, currency)}
          numericValue={monthlySalary}
          formatValue={(n) => formatCurrency(n, currency)}
          info={t('banking.hero.monthlySalaryInfo')}
          infoAriaLabel={t('banking.hero.monthlySalaryInfoAria')}
          isLoading={isLoading}
        />
      ),
    }),
    [checkingBalance, currency, isLoading, monthlySalary, t]
  );
}
